/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedVaultRouteImport } from './routes/_authenticated/vault'
import { Route as AuthenticatedTasksRouteImport } from './routes/_authenticated/tasks'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedHrRouteImport } from './routes/_authenticated/hr'
import { Route as AuthenticatedCustomersRouteImport } from './routes/_authenticated/customers'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedHrIndexRouteImport } from './routes/_authenticated/hr/index'
import { Route as AuthenticatedChatIndexRouteImport } from './routes/_authenticated/chat/index'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account/index'
import { Route as AuthenticatedTasksWorkflowsRouteImport } from './routes/_authenticated/tasks/workflows'
import { Route as AuthenticatedSettingsTeamsRouteImport } from './routes/_authenticated/settings/teams'
import { Route as AuthenticatedSettingsPermissionsRouteImport } from './routes/_authenticated/settings/permissions'
import { Route as AuthenticatedSettingsMembersRouteImport } from './routes/_authenticated/settings/members'
import { Route as AuthenticatedHrTimeOffRouteImport } from './routes/_authenticated/hr/time-off'
import { Route as AuthenticatedChatTopicIdRouteImport } from './routes/_authenticated/chat/$topic-id'
import { Route as AuthenticatedAccountSecurityRouteImport } from './routes/_authenticated/account/security'
import { Route as AuthenticatedAccountDateAndLocaleRouteImport } from './routes/_authenticated/account/date-and-locale'
import { Route as AuthenticatedTasksWorkflowsIndexRouteImport } from './routes/_authenticated/tasks/workflows.index'
import { Route as AuthenticatedTasksWorkflowIdIndexRouteImport } from './routes/_authenticated/tasks/$workflow-id.index'
import { Route as AuthenticatedHrTimeOffIndexRouteImport } from './routes/_authenticated/hr/time-off/index'
import { Route as AuthenticatedTasksWorkflowIdWorkItemIdRouteImport } from './routes/_authenticated/tasks/$workflow-id.$work-item-id'
import { Route as AuthenticatedTasksWorkflowsWorkflowIdEditRouteImport } from './routes/_authenticated/tasks/workflows.$workflowId.edit'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVaultRoute = AuthenticatedVaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksRoute = AuthenticatedTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHrRoute = AuthenticatedHrRouteImport.update({
  id: '/hr',
  path: '/hr',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCustomersRoute = AuthenticatedCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedTasksRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedHrIndexRoute = AuthenticatedHrIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedHrRoute,
} as any)
const AuthenticatedChatIndexRoute = AuthenticatedChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedTasksWorkflowsRoute =
  AuthenticatedTasksWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => AuthenticatedTasksRoute,
  } as any)
const AuthenticatedSettingsTeamsRoute =
  AuthenticatedSettingsTeamsRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsPermissionsRoute =
  AuthenticatedSettingsPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsMembersRoute =
  AuthenticatedSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedHrTimeOffRoute = AuthenticatedHrTimeOffRouteImport.update({
  id: '/time-off',
  path: '/time-off',
  getParentRoute: () => AuthenticatedHrRoute,
} as any)
const AuthenticatedChatTopicIdRoute =
  AuthenticatedChatTopicIdRouteImport.update({
    id: '/chat/$topic-id',
    path: '/chat/$topic-id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountSecurityRoute =
  AuthenticatedAccountSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountDateAndLocaleRoute =
  AuthenticatedAccountDateAndLocaleRouteImport.update({
    id: '/date-and-locale',
    path: '/date-and-locale',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedTasksWorkflowsIndexRoute =
  AuthenticatedTasksWorkflowsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTasksWorkflowsRoute,
  } as any)
const AuthenticatedTasksWorkflowIdIndexRoute =
  AuthenticatedTasksWorkflowIdIndexRouteImport.update({
    id: '/$workflow-id/',
    path: '/$workflow-id/',
    getParentRoute: () => AuthenticatedTasksRoute,
  } as any)
const AuthenticatedHrTimeOffIndexRoute =
  AuthenticatedHrTimeOffIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedHrTimeOffRoute,
  } as any)
const AuthenticatedTasksWorkflowIdWorkItemIdRoute =
  AuthenticatedTasksWorkflowIdWorkItemIdRouteImport.update({
    id: '/$workflow-id/$work-item-id',
    path: '/$workflow-id/$work-item-id',
    getParentRoute: () => AuthenticatedTasksRoute,
  } as any)
const AuthenticatedTasksWorkflowsWorkflowIdEditRoute =
  AuthenticatedTasksWorkflowsWorkflowIdEditRouteImport.update({
    id: '/$workflowId/edit',
    path: '/$workflowId/edit',
    getParentRoute: () => AuthenticatedTasksWorkflowsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/onboarding': typeof OnboardingRoute
  '/account': typeof AuthenticatedAccountRouteWithChildren
  '/customers': typeof AuthenticatedCustomersRoute
  '/hr': typeof AuthenticatedHrRouteWithChildren
  '/reports': typeof AuthenticatedReportsRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/tasks': typeof AuthenticatedTasksRouteWithChildren
  '/vault': typeof AuthenticatedVaultRoute
  '/account/date-and-locale': typeof AuthenticatedAccountDateAndLocaleRoute
  '/account/security': typeof AuthenticatedAccountSecurityRoute
  '/chat/$topic-id': typeof AuthenticatedChatTopicIdRoute
  '/hr/time-off': typeof AuthenticatedHrTimeOffRouteWithChildren
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/permissions': typeof AuthenticatedSettingsPermissionsRoute
  '/settings/teams': typeof AuthenticatedSettingsTeamsRoute
  '/tasks/workflows': typeof AuthenticatedTasksWorkflowsRouteWithChildren
  '/account/': typeof AuthenticatedAccountIndexRoute
  '/chat/': typeof AuthenticatedChatIndexRoute
  '/hr/': typeof AuthenticatedHrIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/tasks/$workflow-id/$work-item-id': typeof AuthenticatedTasksWorkflowIdWorkItemIdRoute
  '/hr/time-off/': typeof AuthenticatedHrTimeOffIndexRoute
  '/tasks/$workflow-id/': typeof AuthenticatedTasksWorkflowIdIndexRoute
  '/tasks/workflows/': typeof AuthenticatedTasksWorkflowsIndexRoute
  '/tasks/workflows/$workflowId/edit': typeof AuthenticatedTasksWorkflowsWorkflowIdEditRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/onboarding': typeof OnboardingRoute
  '/customers': typeof AuthenticatedCustomersRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/vault': typeof AuthenticatedVaultRoute
  '/': typeof AuthenticatedIndexRoute
  '/account/date-and-locale': typeof AuthenticatedAccountDateAndLocaleRoute
  '/account/security': typeof AuthenticatedAccountSecurityRoute
  '/chat/$topic-id': typeof AuthenticatedChatTopicIdRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/permissions': typeof AuthenticatedSettingsPermissionsRoute
  '/settings/teams': typeof AuthenticatedSettingsTeamsRoute
  '/account': typeof AuthenticatedAccountIndexRoute
  '/chat': typeof AuthenticatedChatIndexRoute
  '/hr': typeof AuthenticatedHrIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/tasks/$workflow-id/$work-item-id': typeof AuthenticatedTasksWorkflowIdWorkItemIdRoute
  '/hr/time-off': typeof AuthenticatedHrTimeOffIndexRoute
  '/tasks/$workflow-id': typeof AuthenticatedTasksWorkflowIdIndexRoute
  '/tasks/workflows': typeof AuthenticatedTasksWorkflowsIndexRoute
  '/tasks/workflows/$workflowId/edit': typeof AuthenticatedTasksWorkflowsWorkflowIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/onboarding': typeof OnboardingRoute
  '/_authenticated/account': typeof AuthenticatedAccountRouteWithChildren
  '/_authenticated/customers': typeof AuthenticatedCustomersRoute
  '/_authenticated/hr': typeof AuthenticatedHrRouteWithChildren
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/tasks': typeof AuthenticatedTasksRouteWithChildren
  '/_authenticated/vault': typeof AuthenticatedVaultRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/account/date-and-locale': typeof AuthenticatedAccountDateAndLocaleRoute
  '/_authenticated/account/security': typeof AuthenticatedAccountSecurityRoute
  '/_authenticated/chat/$topic-id': typeof AuthenticatedChatTopicIdRoute
  '/_authenticated/hr/time-off': typeof AuthenticatedHrTimeOffRouteWithChildren
  '/_authenticated/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/_authenticated/settings/permissions': typeof AuthenticatedSettingsPermissionsRoute
  '/_authenticated/settings/teams': typeof AuthenticatedSettingsTeamsRoute
  '/_authenticated/tasks/workflows': typeof AuthenticatedTasksWorkflowsRouteWithChildren
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
  '/_authenticated/chat/': typeof AuthenticatedChatIndexRoute
  '/_authenticated/hr/': typeof AuthenticatedHrIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/tasks/$workflow-id/$work-item-id': typeof AuthenticatedTasksWorkflowIdWorkItemIdRoute
  '/_authenticated/hr/time-off/': typeof AuthenticatedHrTimeOffIndexRoute
  '/_authenticated/tasks/$workflow-id/': typeof AuthenticatedTasksWorkflowIdIndexRoute
  '/_authenticated/tasks/workflows/': typeof AuthenticatedTasksWorkflowsIndexRoute
  '/_authenticated/tasks/workflows/$workflowId/edit': typeof AuthenticatedTasksWorkflowsWorkflowIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/not-found'
    | '/onboarding'
    | '/account'
    | '/customers'
    | '/hr'
    | '/reports'
    | '/settings'
    | '/tasks'
    | '/vault'
    | '/account/date-and-locale'
    | '/account/security'
    | '/chat/$topic-id'
    | '/hr/time-off'
    | '/settings/members'
    | '/settings/permissions'
    | '/settings/teams'
    | '/tasks/workflows'
    | '/account/'
    | '/chat/'
    | '/hr/'
    | '/settings/'
    | '/tasks/'
    | '/tasks/$workflow-id/$work-item-id'
    | '/hr/time-off/'
    | '/tasks/$workflow-id/'
    | '/tasks/workflows/'
    | '/tasks/workflows/$workflowId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/not-found'
    | '/onboarding'
    | '/customers'
    | '/reports'
    | '/vault'
    | '/'
    | '/account/date-and-locale'
    | '/account/security'
    | '/chat/$topic-id'
    | '/settings/members'
    | '/settings/permissions'
    | '/settings/teams'
    | '/account'
    | '/chat'
    | '/hr'
    | '/settings'
    | '/tasks'
    | '/tasks/$workflow-id/$work-item-id'
    | '/hr/time-off'
    | '/tasks/$workflow-id'
    | '/tasks/workflows'
    | '/tasks/workflows/$workflowId/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/not-found'
    | '/onboarding'
    | '/_authenticated/account'
    | '/_authenticated/customers'
    | '/_authenticated/hr'
    | '/_authenticated/reports'
    | '/_authenticated/settings'
    | '/_authenticated/tasks'
    | '/_authenticated/vault'
    | '/_authenticated/'
    | '/_authenticated/account/date-and-locale'
    | '/_authenticated/account/security'
    | '/_authenticated/chat/$topic-id'
    | '/_authenticated/hr/time-off'
    | '/_authenticated/settings/members'
    | '/_authenticated/settings/permissions'
    | '/_authenticated/settings/teams'
    | '/_authenticated/tasks/workflows'
    | '/_authenticated/account/'
    | '/_authenticated/chat/'
    | '/_authenticated/hr/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/tasks/$workflow-id/$work-item-id'
    | '/_authenticated/hr/time-off/'
    | '/_authenticated/tasks/$workflow-id/'
    | '/_authenticated/tasks/workflows/'
    | '/_authenticated/tasks/workflows/$workflowId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  NotFoundRoute: typeof NotFoundRoute
  OnboardingRoute: typeof OnboardingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vault': {
      id: '/_authenticated/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof AuthenticatedVaultRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks': {
      id: '/_authenticated/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr': {
      id: '/_authenticated/hr'
      path: '/hr'
      fullPath: '/hr'
      preLoaderRoute: typeof AuthenticatedHrRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers': {
      id: '/_authenticated/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedCustomersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedTasksRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/hr/': {
      id: '/_authenticated/hr/'
      path: '/'
      fullPath: '/hr/'
      preLoaderRoute: typeof AuthenticatedHrIndexRouteImport
      parentRoute: typeof AuthenticatedHrRoute
    }
    '/_authenticated/chat/': {
      id: '/_authenticated/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof AuthenticatedChatIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/tasks/workflows': {
      id: '/_authenticated/tasks/workflows'
      path: '/workflows'
      fullPath: '/tasks/workflows'
      preLoaderRoute: typeof AuthenticatedTasksWorkflowsRouteImport
      parentRoute: typeof AuthenticatedTasksRoute
    }
    '/_authenticated/settings/teams': {
      id: '/_authenticated/settings/teams'
      path: '/teams'
      fullPath: '/settings/teams'
      preLoaderRoute: typeof AuthenticatedSettingsTeamsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/permissions': {
      id: '/_authenticated/settings/permissions'
      path: '/permissions'
      fullPath: '/settings/permissions'
      preLoaderRoute: typeof AuthenticatedSettingsPermissionsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/members': {
      id: '/_authenticated/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthenticatedSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/hr/time-off': {
      id: '/_authenticated/hr/time-off'
      path: '/time-off'
      fullPath: '/hr/time-off'
      preLoaderRoute: typeof AuthenticatedHrTimeOffRouteImport
      parentRoute: typeof AuthenticatedHrRoute
    }
    '/_authenticated/chat/$topic-id': {
      id: '/_authenticated/chat/$topic-id'
      path: '/chat/$topic-id'
      fullPath: '/chat/$topic-id'
      preLoaderRoute: typeof AuthenticatedChatTopicIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/security': {
      id: '/_authenticated/account/security'
      path: '/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AuthenticatedAccountSecurityRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/date-and-locale': {
      id: '/_authenticated/account/date-and-locale'
      path: '/date-and-locale'
      fullPath: '/account/date-and-locale'
      preLoaderRoute: typeof AuthenticatedAccountDateAndLocaleRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/tasks/workflows/': {
      id: '/_authenticated/tasks/workflows/'
      path: '/'
      fullPath: '/tasks/workflows/'
      preLoaderRoute: typeof AuthenticatedTasksWorkflowsIndexRouteImport
      parentRoute: typeof AuthenticatedTasksWorkflowsRoute
    }
    '/_authenticated/tasks/$workflow-id/': {
      id: '/_authenticated/tasks/$workflow-id/'
      path: '/$workflow-id'
      fullPath: '/tasks/$workflow-id/'
      preLoaderRoute: typeof AuthenticatedTasksWorkflowIdIndexRouteImport
      parentRoute: typeof AuthenticatedTasksRoute
    }
    '/_authenticated/hr/time-off/': {
      id: '/_authenticated/hr/time-off/'
      path: '/'
      fullPath: '/hr/time-off/'
      preLoaderRoute: typeof AuthenticatedHrTimeOffIndexRouteImport
      parentRoute: typeof AuthenticatedHrTimeOffRoute
    }
    '/_authenticated/tasks/$workflow-id/$work-item-id': {
      id: '/_authenticated/tasks/$workflow-id/$work-item-id'
      path: '/$workflow-id/$work-item-id'
      fullPath: '/tasks/$workflow-id/$work-item-id'
      preLoaderRoute: typeof AuthenticatedTasksWorkflowIdWorkItemIdRouteImport
      parentRoute: typeof AuthenticatedTasksRoute
    }
    '/_authenticated/tasks/workflows/$workflowId/edit': {
      id: '/_authenticated/tasks/workflows/$workflowId/edit'
      path: '/$workflowId/edit'
      fullPath: '/tasks/workflows/$workflowId/edit'
      preLoaderRoute: typeof AuthenticatedTasksWorkflowsWorkflowIdEditRouteImport
      parentRoute: typeof AuthenticatedTasksWorkflowsRoute
    }
  }
}

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountDateAndLocaleRoute: typeof AuthenticatedAccountDateAndLocaleRoute
  AuthenticatedAccountSecurityRoute: typeof AuthenticatedAccountSecurityRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountDateAndLocaleRoute:
    AuthenticatedAccountDateAndLocaleRoute,
  AuthenticatedAccountSecurityRoute: AuthenticatedAccountSecurityRoute,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedHrTimeOffRouteChildren {
  AuthenticatedHrTimeOffIndexRoute: typeof AuthenticatedHrTimeOffIndexRoute
}

const AuthenticatedHrTimeOffRouteChildren: AuthenticatedHrTimeOffRouteChildren =
  {
    AuthenticatedHrTimeOffIndexRoute: AuthenticatedHrTimeOffIndexRoute,
  }

const AuthenticatedHrTimeOffRouteWithChildren =
  AuthenticatedHrTimeOffRoute._addFileChildren(
    AuthenticatedHrTimeOffRouteChildren,
  )

interface AuthenticatedHrRouteChildren {
  AuthenticatedHrTimeOffRoute: typeof AuthenticatedHrTimeOffRouteWithChildren
  AuthenticatedHrIndexRoute: typeof AuthenticatedHrIndexRoute
}

const AuthenticatedHrRouteChildren: AuthenticatedHrRouteChildren = {
  AuthenticatedHrTimeOffRoute: AuthenticatedHrTimeOffRouteWithChildren,
  AuthenticatedHrIndexRoute: AuthenticatedHrIndexRoute,
}

const AuthenticatedHrRouteWithChildren = AuthenticatedHrRoute._addFileChildren(
  AuthenticatedHrRouteChildren,
)

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsMembersRoute: typeof AuthenticatedSettingsMembersRoute
  AuthenticatedSettingsPermissionsRoute: typeof AuthenticatedSettingsPermissionsRoute
  AuthenticatedSettingsTeamsRoute: typeof AuthenticatedSettingsTeamsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsMembersRoute: AuthenticatedSettingsMembersRoute,
  AuthenticatedSettingsPermissionsRoute: AuthenticatedSettingsPermissionsRoute,
  AuthenticatedSettingsTeamsRoute: AuthenticatedSettingsTeamsRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedTasksWorkflowsRouteChildren {
  AuthenticatedTasksWorkflowsIndexRoute: typeof AuthenticatedTasksWorkflowsIndexRoute
  AuthenticatedTasksWorkflowsWorkflowIdEditRoute: typeof AuthenticatedTasksWorkflowsWorkflowIdEditRoute
}

const AuthenticatedTasksWorkflowsRouteChildren: AuthenticatedTasksWorkflowsRouteChildren =
  {
    AuthenticatedTasksWorkflowsIndexRoute:
      AuthenticatedTasksWorkflowsIndexRoute,
    AuthenticatedTasksWorkflowsWorkflowIdEditRoute:
      AuthenticatedTasksWorkflowsWorkflowIdEditRoute,
  }

const AuthenticatedTasksWorkflowsRouteWithChildren =
  AuthenticatedTasksWorkflowsRoute._addFileChildren(
    AuthenticatedTasksWorkflowsRouteChildren,
  )

interface AuthenticatedTasksRouteChildren {
  AuthenticatedTasksWorkflowsRoute: typeof AuthenticatedTasksWorkflowsRouteWithChildren
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTasksWorkflowIdWorkItemIdRoute: typeof AuthenticatedTasksWorkflowIdWorkItemIdRoute
  AuthenticatedTasksWorkflowIdIndexRoute: typeof AuthenticatedTasksWorkflowIdIndexRoute
}

const AuthenticatedTasksRouteChildren: AuthenticatedTasksRouteChildren = {
  AuthenticatedTasksWorkflowsRoute:
    AuthenticatedTasksWorkflowsRouteWithChildren,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTasksWorkflowIdWorkItemIdRoute:
    AuthenticatedTasksWorkflowIdWorkItemIdRoute,
  AuthenticatedTasksWorkflowIdIndexRoute:
    AuthenticatedTasksWorkflowIdIndexRoute,
}

const AuthenticatedTasksRouteWithChildren =
  AuthenticatedTasksRoute._addFileChildren(AuthenticatedTasksRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
  AuthenticatedCustomersRoute: typeof AuthenticatedCustomersRoute
  AuthenticatedHrRoute: typeof AuthenticatedHrRouteWithChildren
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedTasksRoute: typeof AuthenticatedTasksRouteWithChildren
  AuthenticatedVaultRoute: typeof AuthenticatedVaultRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedChatTopicIdRoute: typeof AuthenticatedChatTopicIdRoute
  AuthenticatedChatIndexRoute: typeof AuthenticatedChatIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
  AuthenticatedCustomersRoute: AuthenticatedCustomersRoute,
  AuthenticatedHrRoute: AuthenticatedHrRouteWithChildren,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedTasksRoute: AuthenticatedTasksRouteWithChildren,
  AuthenticatedVaultRoute: AuthenticatedVaultRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedChatTopicIdRoute: AuthenticatedChatTopicIdRoute,
  AuthenticatedChatIndexRoute: AuthenticatedChatIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  NotFoundRoute: NotFoundRoute,
  OnboardingRoute: OnboardingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
